import React, { useState } from "react";
import { Autocomplete, TextField, StandardTextFieldProps } from "@mui/material";

interface EmailAutocompleteProps extends Omit<StandardTextFieldProps, "value" | "onChange"> {
  label?: string;
  value?: string;
  onChange?: (value: string) => void;
  customClassName?: string;
  error?: boolean;
  helperText?: React.ReactNode;
}

const EmailAutocomplete: React.FC<EmailAutocompleteProps> = ({
  label = "E-mail",
  value = "",
  onChange,
  customClassName,
  error,
  helperText,
  ...rest
}) => {
  const { inputProps, InputProps, ...textFieldProps } = rest;
  const [inputValue, setInputValue] = useState(value);
  const [options, setOptions] = useState<string[]>([]);

  const commonDomains = [
    "gmail.com",
    "outlook.com",
    "hotmail.com",
    "yahoo.com",
    "icloud.com",
    "protonmail.com",
    "live.com",
  ];

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setInputValue(value);

    const atIndex = value.indexOf("@");

    if (atIndex > -1) {
      const typedDomain = value.slice(atIndex + 1).toLowerCase();
      const suggestions = commonDomains
        .filter((domain) => domain.startsWith(typedDomain))
        .map((domain) => value.slice(0, atIndex + 1) + domain);
      setOptions(suggestions);
    } else {
      setOptions([]);
    }

    // dispara para o componente pai (caso tenha callback)
    if (onChange) onChange(value);
  };

  return (
    <Autocomplete
      freeSolo
      options={options}
      inputValue={inputValue}
      onInputChange={(event, newValue) => {
        setInputValue(newValue);
        if (onChange) onChange(newValue);
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          {...textFieldProps}
          label={label}
          variant="outlined"
          size="small"
          onChange={handleInputChange}
          error={error}
          helperText={helperText}
          InputProps={{
            ...params.InputProps,
            ...InputProps,
            className: customClassName,
          }}
          inputProps={{
            ...params.inputProps,
            ...inputProps,
          }}
          InputLabelProps={{
            shrink:true,
            ...params.InputLabelProps,
          }}
          sx={{
            "& .MuiOutlinedInput-notchedOutline": {
              border: "none", // remove o contorno do variant="outlined"
            },
            "& .MuiInputBase-root": {
              "&:before, &:after": { display: "none" }, // remove underline (standard/fallback)
              boxShadow: "none",
              borderRadius: "0.75rem",
            },
          }}
        />
      )}
      sx={{
        "& .MuiAutocomplete-listbox": {
        },
      }}
    />
  );
};

export default EmailAutocomplete;
